// /magic-garage — Magic Garage Door (Mansfield, OH)
// Lead Architect: Sabrina Wyeth. Phone: 419-529-2002.
// Skin: Industrial Steel — electric cyan spark on warm charcoal
// with chrome-white accents. Grit & Gear tactile human feel.
import VerticalCockpit from "@/components/VerticalCockpit";
import { PALETTES } from "@/config/AssetSpine";
import { VERTICAL_CONFIG } from "@/config/verticalConfig";

export default function MagicGarage() {
  return (
    <VerticalCockpit
      config={VERTICAL_CONFIG.MAGIC_GARAGE}
      palette={PALETTES.MAGIC_GARAGE}
      testPrefix="mg"
    />
  );
}
